import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import Help from './Help';

function HelpContainer({ isOpen, onClose }) {
    //Estados globales
    const { token } = useGlobalContext();

    //Estados locales
    const [loader, setLoader] = useState(false);
    const [helpText, setHelpText] = useState();

    const Location = useLocation();

    useEffect(() => {
        const getHelptext = async () => {
            try {
                setLoader(true);

                const HelpText = await UserService.getHelpText({
                    token,
                    url: Location.pathname,
                });

                if (HelpText) setHelpText(HelpText.data.ayuda);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getHelptext();
    }, [Location.pathname]);

    return (
        <Help states={{ loader, isOpen, helpText }} functions={{ onClose }} />
    );
}

export default HelpContainer;
